module.exports = __webpack_public_path__ + "img/plante.315b5c9b.svg";